import { useContext } from "react";
import { AuthContext } from "../Contexts/AuthContext";
import { IAuthContextProps } from "../Interfaces/IAuthContextProps";

export function useAuth() : IAuthContextProps {
    const context = useContext(AuthContext);

    if(!context){
        throw new Error('Erro ao utilizar o contexto de autenticação');
    }

    return context;
}